import { environment } from '../../environments/environment';

export const apiBaseUrl =
    process.env.NODE_ENV === 'test' ? new URL('/api', window.location.origin).href : `${environment.accountApiUrl}/api`;
